import {
  Stack,
  Box,
  Typography,
  List,
  ListItem,
  IconButton,
  ListItemText,
} from "@mui/material";
import { useState } from "react";
import CameraCapture from "src/shared/camera-capture";
import { IAttachmentFile } from "src/shared/components/file-uploader";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

interface IProps {
  files: IAttachmentFile[];
  setFiles: Function;
}

const PhotoCapturing: React.FC<IProps> = ({ files, setFiles }) => {
  const { t } = useTranslation();

  const [openCamera, setOpenCamera] = useState(false);

  return (
    <>
      {files.length === 0 ? (
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Box
            onClick={() => setOpenCamera(true)}
            width={"100%"}
            sx={{
              height: 60,
              border: "1px solid",
              borderColor: "primary.main",
              borderRadius: 3,
              bgcolor: "#333333",
              cursor: "pointer",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,

              transition: "0.2s",

              "&:hover": {
                bgcolor: "#3c3c3c",
              },
            }}
          >
            <AddPhotoAlternateOutlinedIcon
              sx={{
                fontSize: 25,
                color: "#9E9E9E",
              }}
            />

            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: "#9E9E9E",
              }}
            >
              {t("uploadPhoto")}
            </Typography>
          </Box>
        </Stack>
      ) : (
        <List
          disablePadding
          sx={{
            border: "1px solid",
            borderColor: "primary.main",
            borderRadius: 3,
          }}
        >
          {files.map((file, index) => (
            <ListItem
              key={`${file.fileName}-${index}`}
              divider={index !== files.length - 1}
              secondaryAction={
                <Stack direction="row" spacing={0}>
                  {(file.downloadUrl || file.file) && (
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => {
                        const url =
                          file.downloadUrl || URL.createObjectURL(file.file!);
                        window.open(url, "_blank");
                      }}
                    >
                      <RemoveRedEyeOutlinedIcon fontSize="small" />
                    </IconButton>
                  )}

                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => setFiles([])}
                  >
                    <DeleteIcon  fontSize="small"  />
                  </IconButton>
                </Stack>
              }
            >
              {(file.downloadUrl || file.file) && (
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1,
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid",
                    borderColor: "divider",
                    mr: 1,
                  }}
                >
                  {file.file?.type.startsWith("image/") ||
                  file.contentType?.startsWith("image/") ? (
                    <img
                      src={file.downloadUrl || URL.createObjectURL(file.file!)}
                      alt={file.fileName}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <DescriptionIcon />
                  )}
                </Box>
              )}

              <ListItemText
                primary={
                  <Typography fontSize={"12px"}>{file.fileName}</Typography>
                }
                secondary={
                  file.size ? (
                    <Typography
                      color={"primary"}
                      fontSize={"12px"}
                    >{`${(file.size / 1024 / 1024).toFixed(2)} MB`}</Typography>
                  ) : (
                    ""
                  )
                }
              />
            </ListItem>
          ))}
        </List>
      )}
      <CameraCapture
        open={openCamera}
        onClose={() => setOpenCamera(false)}
        onCapture={(file) => {
          const attachment: IAttachmentFile = {
            file,
            fileName: file.name,
            size: file.size,
            isUploaded: false,
          };

          console.log({ attachment });
          setFiles([attachment]);
        }}
      />
    </>
  );
};

export default PhotoCapturing;
